import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { SITE } from "@/lib/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white">
    <div className="max-w-[1240px] mx-auto px-5 md:px-8 py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <Logo dark />
          <p className="mt-6 text-[15px] leading-relaxed text-white/70 max-w-sm">
            Wholesale merchandise, perishables, overstock, shelf pulls, and import/export
            sourcing — coordinated from Pembroke Pines, Florida to destinations worldwide.
          </p>
        </div>

        <div data-testid="footer-contact-block">
          <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-white/50">Contact</p>
          <ul className="mt-5 space-y-4 text-[15px]">
            <li>
              <a
                href={SITE.phoneHref}
                data-testid="footer-call-link"
                className="inline-flex items-center gap-3 text-white/85 hover:text-white transition-colors duration-200"
              >
                <Phone size={16} className="text-accent" />
                {SITE.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={SITE.emailHref}
                data-testid="footer-email-link"
                className="inline-flex items-center gap-3 text-white/85 hover:text-white transition-colors duration-200 break-all"
              >
                <Mail size={16} className="text-accent" />
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <MapPin size={16} className="text-accent mt-1 shrink-0" />
              <span>
                {SITE.address.street}
                <br />
                {SITE.address.city}, {SITE.address.state} {SITE.address.zip}
              </span>
            </li>
          </ul>
        </div>

        <div data-testid="footer-policies-block">
          <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-white/50">Policies</p>
          <ul className="mt-5 space-y-3 text-[15px]">
            {SITE.policies.map((p) => (
              <li key={p.path}>
                <Link
                  to={p.path}
                  data-testid={`footer-policy-${p.path.replace("/", "")}-link`}
                  className="text-white/70 hover:text-white transition-colors duration-200"
                >
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-[13px] text-white/45">
        <span data-testid="footer-copyright">© 2026 {SITE.name}. All rights reserved.</span>
        <span className="font-mono tracking-[0.18em] uppercase text-[11px]">
          Wholesale · Import / Export · No retail storefront
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
